import {Autocomplete, Text} from '../1elements'
import {useEffect, useState} from 'react'
import ApiService from '../../common/ApiCalls'
import AddIcon from '@mui/icons-material/Add'
import Box from '@mui/material/Box'

const autocompleteSx = {
    padding: 0,
    maxWidth: '400px',
    '& .MuiInputBase-root': {
        padding: 0
    },
    '& .MuiAutocomplete-inputRoot': {
        maxHeight: '29px'
    },
    '& .MuiInputBase-input': {
        height: '10px'
    }
}

const BuildingNameSearch = ({value, setValue, onAdd, selectedContactType, searchOnly, disabled}) => {
    const [contactNameList, setContactNameList] = useState([])
    const [searchWord, setSearchWord] = useState('')

    const updateSearchWord = (e) => {
        setSearchWord(e.target.value)
    }

    useEffect(()=>{
        setContactNameList([])
    }, [selectedContactType])

    useEffect(()=>{
        if(searchWord.length > 0){
            const keyword = {searchInput: searchWord}
            ApiService().searchContactByName(keyword)
                .then((res)=> {
                    const resultWithoutUserType = res.filter((contact)=>{
                        return contact.contact_type === selectedContactType
                    })
                    setContactNameList(resultWithoutUserType)
                })
                .catch((err)=> {
                    console.log('There was an error on searchContactByName: ', err)
                })
        }else{
            setContactNameList([])
        }
    // XXX Fix this in the future
    // eslint-disable-next-line
    }, [searchWord])

    return(
        <div>
            <Text type={'fieldLabel'}>Contact Name</Text>
            <Autocomplete sx={autocompleteSx} options={contactNameList}
                          optionLabel={'name'} value={value} onChangeTextField={updateSearchWord}
                          onChangeAutocomplete={setValue} disabled={disabled}
            />
            {!searchOnly && <Box sx={{ marginBottom: '40px' }} onClick={onAdd}><Text type={'addBuildingNameCta'}><AddIcon /> Add a new contact</Text></Box>}
        </div>
    )
}

export default BuildingNameSearch
